import { useEffect, useState } from "react"
import { AdministrativeFormItemDTO, AdministrativeFormTaxDTO, Accounting, AccountingAccount } from "../interface/interface"
import { OrderInfo, ItemVaucher } from "../interface/orderOfProvision"
import { findAAById, findAccountingById } from "../servicesHooks/Accounting/useAccountingService"
import { getAllOrdersItems, getAllOrdersTaxes } from "../servicesHooks/OrderOfProvision/useOrderOfProvisionService"

const useOrderOfProvision = () => {
    const [orderInfo, setOrderInfo] = useState<OrderInfo>({
        supplier: null,
        pos: null,
        voucherNumber: null,
        reicipt: null,
        orderDate: new Date(),
        payWithCreditCard: false,
        operationWithSGR: false,
        description: '',
    })

    const [noteCredit, setNoteCredit] = useState<{
        noteCredit: any,
        administrativeFormItems: AdministrativeFormItemDTO[]|null,
        administrativeFormTaxes: AdministrativeFormTaxDTO[]|null
    }>({
        noteCredit: null,
        administrativeFormItems: null,
        administrativeFormTaxes: null
    })
    const [items, setItems] = useState<ItemVaucher[]>([])
    const [accounting, setAccounting] = useState<Accounting|null>(null)
    const [defaultAccountingAccount, setDefaultAccountingAccount] = useState<AccountingAccount | null>(null)
    useEffect(() => {
        if (orderInfo.supplier == null) return
        findAccountingById({ accountingId: orderInfo.supplier.accounting }).then((resp) => setAccounting(resp))
    }, [orderInfo.supplier])

    useEffect(() => {
        if (noteCredit.noteCredit == null) return
        if (items.length > 0) {
            setItems([])
        }
        setDefaultAccountingAccount(null)
        getAllOrdersItems(0, 0, {administrativeForm: noteCredit.noteCredit?.administrativeform }).then((resp) => {
            setNoteCredit((prev) => ({ ...prev, administrativeFormItems: resp }))
        })
        getAllOrdersTaxes(0, 0, {administrativeForm: noteCredit.noteCredit?.administrativeform, isVatTaxes: false }).then((resp) => {
            setNoteCredit((prev) => ({ ...prev, administrativeFormTaxes: resp }))
        })
    }, [noteCredit.noteCredit])

    useEffect(() => {
        if (noteCredit.noteCredit) {
            setNoteCredit({
                noteCredit: null,
                administrativeFormItems: null,
                administrativeFormTaxes: null,
            })
        }
        if (items.length > 0) {
            setItems([])
        }
    }, [orderInfo.supplier, orderInfo.reicipt])

    useEffect(() => {
        if (orderInfo.supplier == null) {
            setDefaultAccountingAccount(null)
            return
        }
        findAAById({
            accountingAccountId: orderInfo.supplier.credit
        }).then((resp) => {
            setDefaultAccountingAccount(resp)
        })
    }, [orderInfo.supplier])

    return { orderInfo, setOrderInfo, noteCredit, setNoteCredit, accounting, items, setItems, defaultAccountingAccount }
}

export function normalize(value, decimals = 2) {
    return parseFloat(value.toFixed(decimals));
}

export default useOrderOfProvision